import React, {useMemo, useRef} from 'react'
import styled from 'styled-components'
import {Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {GiftShopProfileResendVideoItemStandard} from 'pages'
import {GiftShopResendRevisionImageItemVideoExistingProps} from './GiftShopResendRevisionImageItemProps'

const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledVersionContainer = styled.div`
  width: 100%;
  text-align: center;
  padding: ${convertUnit(12)} 0;
  margin-bottom: ${convertUnit(20)};
`

export default function GiftShopResendRevisionImageItemVideoExisting({
  date,
  src,
  title,
  duration,
  size,
  versionTitle,
}: GiftShopResendRevisionImageItemVideoExistingProps) {
  const videoRef = useRef<HTMLVideoElement>(null)

  const handleRenderTitle = useMemo(
    () => (
      <StyledVersionContainer>
        <Paragraph fontSize="m" fontWeight="medium" color="primary_5">
          {versionTitle}
        </Paragraph>
      </StyledVersionContainer>
    ),
    [versionTitle],
  )

  const handleRenderVideo = useMemo(
    () => (
      <GiftShopProfileResendVideoItemStandard
        videoRef={videoRef}
        date={date}
        duration={duration}
        size={size}
        src={src}
        title={title}
      />
    ),
    [date, duration, size, src, title],
  )

  return (
    <StyledColumn>
      {handleRenderTitle}
      {handleRenderVideo}
    </StyledColumn>
  )
}
